export default __webpack_public_path__ + "static/Prostatizal-desktop-xl-6860a6ce535b781d84202c8ce09fc56e.jpg";